var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2880_6167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.8702 32.251H65.6358C64.4974 32.251 63.4148 32.7979 62.7452 33.7354L45.2006 58.0657L37.2541 47.0389C36.5845 46.1126 35.5131 45.5546 34.3635 45.5546H29.1291C28.4037 45.5546 27.9796 46.3804 28.4037 46.972L42.3099 66.2577C42.6385 66.7162 43.0715 67.0898 43.5733 67.3475C44.075 67.6053 44.6309 67.7397 45.195 67.7397C45.759 67.7397 46.315 67.6053 46.8167 67.3475C47.3184 67.0898 47.7515 66.7162 48.08 66.2577L71.5845 33.6684C72.0198 33.0769 71.5957 32.251 70.8702 32.251Z",
    fill: "#FADB14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0C22.3884 0 0 22.3884 0 50C0 77.6116 22.3884 100 50 100C77.6116 100 100 77.6116 100 50C100 22.3884 77.6116 0 50 0ZM50 91.5179C27.0759 91.5179 8.48214 72.9241 8.48214 50C8.48214 27.0759 27.0759 8.48214 50 8.48214C72.9241 8.48214 91.5179 27.0759 91.5179 50C91.5179 72.9241 72.9241 91.5179 50 91.5179Z",
    fill: "#FADB14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2880_6167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleWarning);
export default __webpack_public_path__ + "static/media/CheckCircleWarning.a908e45eb792a7814c6c59bbadd05783.svg";
export { ForwardRef as ReactComponent };